import React, { useState, useRef, useEffect } from "react";
import { Form } from "react-bootstrap";
import "./CitySuggestionInputField.css";

const CitySuggestionInputField = ({
  type,
  formType,
  placeholder,
  className,
  readOnly,
  value,
  onBlur,
  onChange,
  name,
  required,
  suggestions,
  inputRef,
  setError,
  cityLoaded,
  isProfileLoading,
  shouldValidate = true,
  ...props
}) => {
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [filteredSuggestions, setFilteredSuggestions] = useState([]);
  const wrapperRef = useRef(null);

  // Filter suggestions based on input value
  useEffect(() => {
    if (!suggestions || !Array.isArray(suggestions)) return;

    const filtered = suggestions.filter((suggestion) =>
      suggestion.toLowerCase().includes(value.toLowerCase())
    );

    setFilteredSuggestions(filtered);

    if (name === "city" && cityLoaded && shouldValidate) {
      if (
        filtered.length === 0 &&
        ["buyer", "coBuyer", "agent"].includes(formType)
      ) {
        setError((prev) => ({
          ...prev,
          [name]: "Invalid City",
        }));
      } else {
        // remove that field from error object
        setError((prev) => {
          const updatedError = { ...prev };
          delete updatedError[name];
          return updatedError;
        });
      }
    }
  }, [value, suggestions, formType, name]);

  // Handle click outside to close suggestions
  useEffect(() => {
    function handleClickOutside(event) {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setShowSuggestions(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleInputChange = (e) => {
    onChange(e);
  };

  const handleSuggestionClick = (suggestion) => {
    const syntheticEvent = {
      target: {
        name,
        value: suggestion,
      },
    };
    onChange(syntheticEvent);
    setShowSuggestions(false);
  };

  return (
    <div className="suggestion-input-wrapper" ref={wrapperRef}>
      <Form.Control
        name={name}
        type={type}
        value={value}
        ref={(el) => {
          if (inputRef && inputRef.current && name) {
            inputRef.current[name] = el;
          }
        }}
        readOnly={readOnly}
        required={required}
        className={className}
        placeholder={placeholder}
        onBlur={onBlur}
        onChange={handleInputChange}
        onFocus={() => setShowSuggestions(true)}
        {...props}
        style={{
          ...(isProfileLoading && {
            backgroundImage:
              "linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)",
            backgroundSize: "200% 100%",
            animation: "shimmerInput 1.5s infinite linear",
            border: "1px solid rgb(214, 213, 208)",
            color: "transparent",
          }),
        }}
      />

      {showSuggestions && filteredSuggestions.length > 0 && (
        <div className="city-suggestion-dropdown">
          {filteredSuggestions.map((suggestion, index) => (
            <div
              key={index}
              className="city-suggestion-item"
              onClick={() => handleSuggestionClick(suggestion)}
            >
              {suggestion}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default CitySuggestionInputField;
